/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{background:#eef2f4;border-radius:7px;display:block;height:4px;min-width:100px}[_nghost-%COMP%]   .indicator[_ngcontent-%COMP%]{background:#33aa79;border-radius:7px;height:4px;transition:width ease 1s}"];
export { styles as styles };
